import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { FluentProvider } from '@fluentui/react-components';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './contexts/AppContainer';
import { PermissionProvider } from './contexts/PermissionContext';
import ErrorBoundary from './components/ErrorBoundary';
import { createSecurityTheme } from './styles/theme';

// Initialize M365-inspired theme
const securityTheme = createSecurityTheme();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <FluentProvider theme={securityTheme}>
        <Router>
          <AppProvider>
            <PermissionProvider>
              <App />
            </PermissionProvider>
          </AppProvider>
        </Router>
      </FluentProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
